"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APLogistics = void 0;
exports.APLogistics = {
    id: 'apLogistics',
    companyName: 'AP Logistics',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'apLogistics',
    },
    isInternal: false,
    isActive: true,
    countries: ['IT'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVBMb2dpc3RpY3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvQVBMb2dpc3RpY3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxXQUFXLEdBQVU7SUFDOUIsRUFBRSxFQUFFLGFBQWE7SUFDakIsV0FBVyxFQUFFLGNBQWM7SUFDM0IsY0FBYyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztJQUM5QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsYUFBYTtLQUN2QjtJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==